module.exports = __webpack_public_path__ + "img/add.06674052.svg";